/**
 * enableMouseDragScroll
 * ─────────────────────
 * 가로 overflow 스크롤 컨테이너에 마우스 드래그(grab) 스크롤을 활성화합니다.
 * 드래그 거리가 threshold 이하이면 클릭으로 간주하여 카드 링크 이동을 방해하지 않습니다.
 *
 * 사용법:
 *   enableMouseDragScroll(document.querySelector('.my-scroll-list'));
 *   enableMouseDragScroll(el, { threshold: 8 });
 *
 * @param {HTMLElement} scrollEl - 가로 스크롤이 가능한 컨테이너 요소
 * @param {Object}      [opts]
 * @param {number}      [opts.threshold=5] - 이 px 이하 이동은 클릭으로 간주
 */
(function () {
  'use strict';

  function enableMouseDragScroll(scrollEl, opts) {
    if (!scrollEl) return;
    opts = opts || {};
    var DRAG_THRESHOLD = opts.threshold || 5;

    var isDown = false;
    var isDragging = false;
    var dragStartX = 0;
    var dragScrollLeft = 0;
    var dragDistance = 0;

    scrollEl.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      isDragging = false;
      dragDistance = 0;
      dragStartX = e.pageX;
      dragScrollLeft = scrollEl.scrollLeft;
    }, true);

    document.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var walk = e.pageX - dragStartX;
      dragDistance = Math.abs(walk);
      if (!isDragging && dragDistance >= DRAG_THRESHOLD) {
        isDragging = true;
        scrollEl.style.cursor = 'grabbing';
        scrollEl.style.userSelect = 'none';
        scrollEl.style.pointerEvents = 'none';
      }
      if (isDragging) {
        e.preventDefault();
        scrollEl.scrollLeft = dragScrollLeft - walk;
      }
    });

    document.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      isDragging = false;
      scrollEl.style.cursor = 'grab';
      scrollEl.style.removeProperty('user-select');
      scrollEl.style.removeProperty('pointer-events');
    });

    scrollEl.addEventListener('click', function (e) {
      if (dragDistance >= DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
      }
      dragDistance = 0;
    }, true);

    scrollEl.style.cursor = 'grab';
  }

  window.enableMouseDragScroll = enableMouseDragScroll;
})();
